import React from 'react'
import ContentHeader from '@Components/ContentHeader'
import './index.scss'

const RightsholderRegistrationSceneHeader = () => (
    <div className="rightsholder-registration-scene-header">
        <ContentHeader
            title="Create a Member"
            descriptionElement={
                <>
                    <p>
                        If you are a self-administered songwriter without a publisher through your PRO or legal
                        publishing entity, we encourage you to create a publishing name. This helps to differentiate
                        your publisher from your songwriter name within work registrations through The MLC Portal.
                    </p>
                    <p>Examples of a publishing name: [Firstname Lastname] Songs[Firstname Lastname] Publishing</p>
                </>
            }
        />
    </div>
)

export default RightsholderRegistrationSceneHeader
